// extracted by mini-css-extract-plugin
export default {"row":"PriceAndAmount_row__Fy7nr","title":"PriceAndAmount_title__8DCl9","errorMessage":"PriceAndAmount_errorMessage__MSmpT"};